import api from './axios';

// Public API
export const publicAPI = {
  getSamples: (params) => api.get('/public/samples', { params }),
  getSampleById: (id) => api.get(`/public/samples/${id}`),
  getStats: (params) => api.get('/public/stats', { params }),
  getParameterStats: (params) => api.get('/public/stats/parameters', { params }),
  getMapData: (params) => api.get('/public/map', { params }),
  getFilters: () => api.get('/public/filters'),
  getDistricts: () => api.get('/public/districts'),
  getStates: () => api.get('/public/states'),
  getStateStats: (params) => api.get('/public/stats/states', { params }),
  getDistrictStats: (params) => api.get('/public/stats/districts', { params }),
  getLocationTypes: () => api.get('/public/location-types'),
  getLocationTypeAnalysis: (params) => api.get('/public/location-type-analysis', { params }),
  // New endpoints for analytics
  getMasterLocationTypes: () => api.get('/public/master-location-types'),
  getLocationTypeStats: (params) => api.get('/public/stats/location-type', { params }),
  getSamplesByParameter: (params) => api.get('/public/samples/by-parameter', { params }),
  // Download PDF report (public)
  downloadPDF: async (id, sampleId) => {
    const response = await api.get(`/public/samples/${id}/pdf`, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${sampleId || 'sample'}-report.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};

export default publicAPI;
